import { render } from "./NewsEditor.vue?vue&type=template&id=1127084c"
import script from "./NewsEditor.vue?vue&type=script&lang=js"
export * from "./NewsEditor.vue?vue&type=script&lang=js"

import "./NewsEditor.vue?vue&type=style&index=0&id=1127084c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__